// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** Apple授权登录 POST /app-auth/apple/login */
export async function appAuthAppleLoginUsingPOST(
  body: API.AppleLoginReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultAppLoginResp>('/app-auth/apple/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** Apple一键注册 POST /app-auth/apple/one-key-register */
export async function appAuthAppleOneKeyRegisterUsingPOST(
  body: API.TokenValidateReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultAppLoginResp>('/app-auth/apple/one-key-register', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** Apple注册 POST /app-auth/apple/register */
export async function appAuthAppleRegisterUsingPOST(
  body: API.AppleRegisterNewReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultAppLoginResp>('/app-auth/apple/register', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** App用户注销 POST /app-auth/cancel */
export async function appAuthCancelUsingPOST(
  body: API.AppCancelNewReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultVoid>('/app-auth/cancel', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** App用户登录 POST /app-auth/login */
export async function appAuthLoginUsingPOST(
  body: API.AppLoginNewReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultAppLoginResp>('/app-auth/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** App一键登录 POST /app-auth/one-key-login */
export async function appAuthOneKeyLoginUsingPOST(
  body: API.TokenValidateReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultAppLoginResp>('/app-auth/one-key-login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** App微信登录 POST /app-auth/wx/login */
export async function appAuthWxLoginUsingPOST(
  body: API.AppWxLoginReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultAppLoginResp>('/app-auth/wx/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** App微信授权后一键登录 POST /app-auth/wx/one-key-register */
export async function appAuthWxOneKeyRegisterUsingPOST(
  body: API.AppWxRegisterNewReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultAppLoginResp>('/app-auth/wx/one-key-register', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** App微信注册 POST /app-auth/wx/register */
export async function appAuthWxRegisterUsingPOST(
  body: API.AppWxRegisterNewReq,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultAppLoginResp>('/app-auth/wx/register', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
